import { render, staticRenderFns } from "./CounterpartySaferWatch.vue?vue&type=template&id=6860afba&scoped=true"
import script from "./CounterpartySaferWatch.vue?vue&type=script&lang=js"
export * from "./CounterpartySaferWatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6860afba",
  null
  
)

export default component.exports